import { type StateType } from '../../../states';
import { type EntitiesTeasers } from '../../../states/entities/teasers';
import { type Selector } from '../../../types/selectors';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyArray: [] = [];

export const selectEntitiesTeasers: Selector<EntitiesTeasers> = (state: StateType) =>
  selectEntitiesState(state)?.teasers ?? emptyArray;
